function Button({ children, type, disabled, onClick, className, loading = false }) {
    return (
        <button
            className={`${
                className || ''
            } inline-flex min-h-[2.5rem] items-center justify-center rounded-md border border-transparent bg-primary px-4 py-2 text-sm font-medium text-gray-100 shadow hover:bg-blue-800 disabled:border-gray-200 disabled:bg-gray-100 disabled:text-gray-400`}
            type={type || 'button'}
            disabled={disabled}
            onClick={onClick}
        >
            {loading ? (
                <svg className="h-5 w-5 animate-spin text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
            ) : (
                children
            )}
        </button>
    );
}

export default Button;
